import { defineStore } from 'pinia';
import { ref } from 'vue';
import api from '../api/axios';

export interface Announcement {
    id: number;
    title: string;
    content: string;
    type: 'info' | 'important' | 'warning';
    created_at: string;
}

export const useAnnouncementStore = defineStore('announcement', () => {
    const announcements = ref<Announcement[]>([]);
    const loading = ref(false);

    async function fetchAnnouncements() {
        loading.value = true;
        try {
            const response = await api.get('/announcements');
            announcements.value = response.data.data;
        } catch (error) {
            console.error('Failed to fetch announcements', error);
        } finally {
            loading.value = false;
        }
    }

    return {
        announcements,
        loading,
        fetchAnnouncements
    };
});
